import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useQuestionsModule } from "./useQuestionsModule";
import { QuestionField } from "./QuestionField";
export const Questions = (props) => {
    const { sequenceNumber } = props;
    const { moduleConfig } = useQuestionsModule(sequenceNumber);
    return (_jsx(_Fragment, { children: moduleConfig.QuestionBuilder.map((question) => {
            return _jsx(QuestionField, { sequenceNumber: sequenceNumber, question: question }, question.QuestionSKU);
        }) }));
};
